import React from "react";
import useDefaultVehicleSnippets from "@/features/getByTransfer/features/snippets/hooks/useDefaultVehicleSnippets";
import VehicleSnippets from "@/features/getByTransfer/features/snippets/components/VehicleSnippets";
import Translation from "@/features/translation/components/Translation";
import Notification from "@/features/notification/components/Notification";
import TransfersVehicleType from "../types/TransfersVehicle.type";
import { TransfersDataType } from "../types/TransfersData.type";
import {useIsAircash} from "@Hooks/selector/useIsAircash";

interface GetByTransferNoResultsNotificationProps {
    fromName: string,
    toName: string,
    vehicles?: TransfersVehicleType[] | TransfersDataType,
    showNotification?: boolean,
}

function GetByTransferNoResultsNotification({fromName, toName, vehicles, showNotification = true}: GetByTransferNoResultsNotificationProps) {
    const defaultVehicleSnippets = useDefaultVehicleSnippets();
    const isAircash = useIsAircash();

    // Don't render GetByTransferNoResultsNotification for Aircash stores
    if (isAircash) {
        return null;
    }

    return (
        <>
            {showNotification && (
                <Notification
                    notificationType="blue"
                    additionalClass="no-results__gbt-notification"
                >
                    <h5>
                        <Translation translationKey="transfers_banner.no_results_title"/>
                    </h5>
                    <Translation
                        translationKey="transfers_banner.no_results_notification"
                        translationVariables={{
                            departureStation: fromName,
                            destinationStation: toName,
                        }}
                    />
                </Notification>
            )}
            <VehicleSnippets
                vehicles={vehicles as TransfersVehicleType[] || defaultVehicleSnippets}
            />
        </>
    )
}

export default GetByTransferNoResultsNotification